import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { type Product } from './ProductCard.vue';

interface Label {
  featureId: string;
  featureValue: string | number;
  width: number;
  height: number;
  alt: string;
  class: string;
  imageSrc: string;
  isActive: (product: Product) => boolean;
}

interface Props {
  product: Product;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FeatureLabelGroup',
  props: {
    product: null
  },
  setup(__props: any) {

const props = __props as {
  product: Product;
};



const AVAILABLE_LABELS: Label[] = [
  {
    featureId: 'PRODUCT_SERIES',
    featureValue: 'Hexagon',
    width: 120,
    height: 67,
    alt: 'hexagon-label',
    class: 'hexagon-label',
    imageSrc: '/img/product-features/hexagon-2x.png',
    isActive(product: Product) {
      return product.feature_groups.some((featureGroup) =>
        featureGroup.features.some(
          (feature) =>
            feature.external_cf_id === this.featureId &&
            feature.value === this.featureValue,
        ),
      );
    },
  },
  {
    featureId: 'ARCHIVE_STATUS',
    featureValue: 8,
    width: 97,
    height: 27,
    alt: 'archive-label',
    class: 'archive-label',
    imageSrc: '/img/product-features/archive-2x.png',
    isActive(product: Product) {
      return product.status === this.featureValue;
    },
  },
];

const getLabelsToRender = (product: Product, availableLabels: Label[]) => {
  return availableLabels.filter((label) => label.isActive(product));
};

const labelsToRender = computed(() =>
  getLabelsToRender(props.product, AVAILABLE_LABELS),
);

return { __sfc: true,props, AVAILABLE_LABELS, getLabelsToRender, labelsToRender }
}

})